export const DUPLICATED_TAB_KEY = "duplicatedTab";
